import { useEffect, useState } from "react";
import { Eye, X } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

function readCookie(name) {
  return document.cookie.split(";").map(c => c.trim()).find(c => c.startsWith(name + "="))?.slice(name.length + 1);
}

export default function ImpersonationBanner() {
  const [admin, setAdmin] = useState(null);
  useEffect(() => {
    const v = readCookie("impersonated_by");
    if (v) setAdmin(decodeURIComponent(v));
  }, []);
  if (!admin) return null;
  const stop = async () => {
    try {
      await api.post("/admin/impersonate/stop");
      toast.success("Impersonation terminata");
      window.location.href = "/admin";
    } catch (err) { toast.error(err?.response?.data?.detail || "Errore"); }
  };
  return (
    <div className="bg-blue-700 text-white text-xs px-4 py-2 flex items-center gap-3 sticky top-0 z-50" data-testid="impersonation-banner">
      <Eye className="w-3.5 h-3.5" />
      <span>
        Stai accedendo come <strong>cliente</strong> (impersonation attiva — admin: <code>{admin}</code>). Tutte le azioni vengono loggate.
      </span>
      <button onClick={stop} className="ml-auto inline-flex items-center gap-1 underline hover:no-underline" data-testid="impersonation-stop">
        <X className="w-3 h-3" /> Esci da impersonation
      </button>
    </div>
  );
}
